export default class yearSituationResolver {
	constructor(age, retirementAge, lifeExpectancy, INSSage) {
		this.age = age
		this.retirementAge = retirementAge
		this.lifeExpectancy = lifeExpectancy
		this.INSSage = INSSage
		return this
	}

	isRetired(i) {
		return i >= this.retirementAge
	}

	hasINSS(i) {
		if(!this.INSSage){
			return false
		}
		return i >= this.INSSage
	}

	isAlive(i, risk = 0) {
		return i >= this.age && i <= (this.lifeExpectancy - risk)
	}

	isSaving(i) {
		return this.isAlive(i) && !this.isRetired(i)
	}

	isConsumingSavings(i) {
		return this.isRetired(i) && this.isAlive(i)
	}

	getSituations(i, risk) {
		return {
			hasINSS: this.hasINSS(i),
			savingYear: this.isSaving(i),
			retiredYear: this.isConsumingSavings(i),
			isAlive: this.isAlive(i, risk)
		}
	}
}
